import store from '../store'

const notifySuccess = (message, title = null) => {
  store.dispatch('toast/show', { message, title: title || 'Success', type: 'success' })
}

const notifyError = (message, title = null) => {
  store.dispatch('toast/show', { message, title: title || 'Error', type: 'error' })
}

const notifyWarning = (message, title = null) => {
  store.dispatch('toast/show', { message, title: title || 'Warning', type: 'warning' })
}

export { notifySuccess, notifyError, notifyWarning }
